import React, { useState, useEffect } from 'react';
import { useDispatch } from '../../../../../chronusStore/helper';
import { eventsListingActions } from '../../../../../chronusStore/slice/eventsListing';
import ChrModal from '../../../../generic/Utils/ChrModal';
import i18n from '../../../../../utils/ChrI18n';
import SpinningLoader from '../../../../generic/Utils/SpinningLoader';
import ChronusApi from '../../../../../services/ChronusApi';
import ConfettiModalContent from './ConfettiModalContent';
import { chronusStore } from '../../../../../chronusStore';

const ConfettiModal = props => {
  const [modalContent, setModalContent] = useState(props.modalContent);
  const dispatch = useDispatch();

  const onHide = () => {
    props.modalOptions.hideModal();
    const quickViewEventId = chronusStore.getState().eventsListing.quickViewEventId;
    if(quickViewEventId)
      dispatch(eventsListingActions.updateRefreshQuickView(true));
    else if(props.reloadPageOnModalClose)
      location.reload();
    else
      dispatch(eventsListingActions.incrementReRenderTabContentCounter());
  }

  useEffect(() => {
    if(!modalContent)
      ChronusApi.postUrlJSON(props.url).then(response => {
        setModalContent(response.data);
      }).catch(_error => {
        ChronusValidator.ErrorManager.ShowPageFlash(false, i18n.t("common_text.error_msg.something_went_wrong"));
      });
  }, [])

  return(
    <ChrModal { ...props.modalOptions } hideModal={ onHide } hideHeader>
      {
        modalContent ? <ConfettiModalContent
          modalContent={ modalContent }
          onClose={ onHide }
        /> :
        <SpinningLoader />
      }
    </ChrModal>
  );
}

export default ConfettiModal;